<template>
  <div class="weui-cell weui-cell_access" @click="select">
    <div class="weui-cell__hd">
      <label for class="weui-label">{{label}}</label>
    </div>
    <div class="weui-cell__bd" :class="bodyCls" v-format="format">{{value}}</div>
    <div class="weui-cell__ft">
      <span v-show="!value">请选择</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    format: {
      type: String,
      default: "yyyy-MM-dd",
    },
    value: String,
    bodyCls: String
  },
  methods: {
    select() {
      var me = this,
        date = me.value ? new Date(me.value.replace(/-/g, "/")) : new Date(),
        year = date.getFullYear(),
        month = date.getMonth() + 1,
        day = date.getDate();

      me.$weui.datePicker({
        defaultValue: [year, month, day],
        onConfirm: function (r) {
          var date = new Date(r[0].value, r[1].value - 1, r[2].value),
            val = me.dateFormat(date, "yyyy-MM-dd hh:mm:ss");
          me.$emit("input", val);
        },
      });
    },
  },
};
</script>